import constate from "constate";
import { useState } from "react";

/**
 * This provider is used to manage the accordion state for the documents page.
 * It is used to store the expanded state of the completed and optional documents accordions.
 * This is needed as we want to preserve the expanded/collapsed state of the accordions
 * when navigating between document list page and document details page.
 */
function useDocumentsPageAccordion() {
  const [completedDocumentsExpanded, setCompletedDocumentsExpanded] = useState(false);
  const [optionalDocumentsExpanded, setOptionalDocumentsExpanded] = useState(false);

  return {
    completedDocumentsExpanded,
    optionalDocumentsExpanded,
    setCompletedDocumentsExpanded,
    setOptionalDocumentsExpanded,
  };
}

export const [DocumentsPageAccordionProvider, useDocumentsPageAccordionContext] =
  constate(useDocumentsPageAccordion);
